<template>
  <div class="detail-level-box">
    <p class="module-title">经过分析，你的能力处于{{level}}阶段</p>
    <div class="level-box">
      <div class="level-line">
        <div class="level-active" :style="{width}"></div>
      </div>
      <div class="level-icon" v-for="(item, index) in levelList" :key="item" :class="[formattingIcom(index) ? 'finished' : 'unfinished']"></div>
<!--      -->
    </div>
    <div class="level-block-box">
      <div class="level-item" v-for="item in levelList" :key="item">
        {{item}}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "detail-level",
    props: {
      level: {
        type: String,
        default: "初级",
      }
    },
    data(){
      return {
        levelList: ['初级', '中级', '高级/主管', '资深/经理', '专家/总监']
      }
    },
    computed: {
      width(){
        let { level } = this
        if(level.includes('初级')){
          return '8%'
        }else if(level.includes('中级')){
          return '30%'
        }else if(level.includes('高级')){
          return '50%'
        }else if(level.includes('主管')){
          return '50%'
        }else if(level.includes('资深')){
          return '70%'
        }else if(level.includes('经理')){
          return '70%'
        }else if(level.includes('专家')){
          return '100%'
        }else if(level.includes('总监')){
          return '100%'
        }
      }
    },
    methods: {
      formattingIcom(index){
        let { level } = this
        if(level.includes('初级')){
          return index <= 0
        }else if(level.includes('中级')){
          return index <= 1
        }else if(level.includes('高级')){
          return index <= 2
        }else if(level.includes('主管')){
          return index <= 2
        }else if(level.includes('资深')){
          return index <= 3
        }else if(level.includes('经理')){
          return index <= 3
        }else if(level.includes('专家')){
          return index <= 4
        }else if(level.includes('总监')){
          return index <= 4
        }
      }
    }
  }
</script>

<style scoped lang="scss">
.detail-level-box{
  width: 1200px;
  height: 223px;
  box-shadow: 0px 2px 48px 0px rgba(25, 28, 36, 0.5);
  border-radius: 12px;
  background-image: url("https://files.wondercv.com/PC/editor/planning/jobs/bgcard1.png");
  box-sizing: border-box;
  background-size: 100%;
  margin-bottom: 50px;
  padding: 32px;
  .module-title{
    font-size: 20px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 28px;
    margin-bottom: 27px;
  }
  .level-box{
    width: 100%;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 82px;
    position: relative;
    box-sizing: border-box;
    margin-bottom: 20px;
    .level-line{
      height: 8px;
      border-radius: 5px;
      top: 12px;
      left: 0px;
      right: 0;
      bottom: 12px;
      background: #424753;
      box-shadow: 0px 0px 6px 0px inset rgba(0, 0, 0, 0.5);
      position: absolute;
      .level-active{
        border-radius: 5px;
        background: #FFAB69;
        width: 0%;
        height: 100%;
        box-shadow: 0px 0px 4px 0px inset #E52B02;
      }
    }
    .level-icon{
      width: 32px;
      height: 32px;
      border-radius: 50%;
      position: relative;
      background-size: 100%;
      &.finished{
        background-image: url("https://files.wondercv.com/PC/editor/planning/jobs/progress/finished.png");
      }
      &.unfinished{
        background-image: url("https://files.wondercv.com/PC/editor/planning/jobs/progress/unfinished.png");
      }
    }
  }
  .level-block-box{
    display: flex;
    justify-content: space-between;
    .level-item{
      width: 200px;
      height: 48px;
      background: #22252B;
      border-radius: 8px;
      text-align: center;
      line-height: 48px;
      color: #fff;
    }
  }
}
</style>
